import { Routes } from '@angular/router';
import { CheckStaffAccessComponent } from 'src/shared/components/authentication/checkstaffaccess/checkstaffaccess.component';
import { ForgottenPasswordComponent } from 'src/shared/components/authentication/forgottenpassword/forgottenpassword.component';
import { LoginComponent } from 'src/shared/components/authentication/login/login.component';
import { RegisterComponent } from 'src/shared/components/authentication/register/register.component';
import { TenantsComponent } from 'src/shared/components/authentication/tenants/tenants.component';
import { NotAuthorisedComponent } from 'src/shared/components/notauthorised/notauthorised.component';
import { NotFoundComponent } from 'src/shared/components/notfound/notfound.component';
import { MAINTENANCE_WINDOW_PATH } from 'src/shared/constants/maintenance-window.constants';
import { LoginGuard } from 'src/shared/guards/login.guard';
import { maintenanceGuard } from 'src/shared/guards/maintenance-window.guard';
import { SymptomCheckerRoutes } from './symptomchecker/symptomchecker-routes';
import { ShopRoutes } from './shop/shop-routes';
import { SecurityRoutes } from './security/security-routes';
import { DemoRoutes } from './demo/demo-routes';
import { SchedulingRoutes } from './scheduling/scheduling-routes';
import { OnboardingRoutes } from './onboarding/onboarding-routes';
import { MaintenanceRoutes } from './maintenance/maintenance-routes';
import { DashboardRoutes } from './dashboard/dashboard-routes';
import { ConsultationSetupRoutes } from './consultation-setup/consultation-setup-routes';
import { CustomerSuccessAdminRoutes } from './customer-success-admin/customer-success-admin-routes';
import { AccountRoutes } from './account/account-routes';
import { UsersRoutes } from './users/users-routes';
import { PrescriptionsRoutes } from './prescriptions/prescriptions-routes';
import { TrialsRoutes } from './tms/trials-routes';
import { EntitlementsRoutes } from './entitlements/entitlements-routes';
import { JoiiSessionsRoutes } from './joii-sessions/joii-sessions-routes';
import { AuthenticatedContainerComponent } from './shared/components/authenticated-container/authenticated-container.component';

export const PortalRoutes: Routes = [
  // Authentication routes
  { path: 'checkaccess', component: CheckStaffAccessComponent, canActivate: [maintenanceGuard, LoginGuard] },
  { path: 'login', component: LoginComponent, canActivate: [maintenanceGuard] },
  { path: 'register', component: RegisterComponent, canActivate: [maintenanceGuard] },
  { path: 'forgottenpassword', component: ForgottenPasswordComponent, canActivate: [maintenanceGuard] },
  { path: 'tenants/:redirectUrl', component: TenantsComponent, canActivate: [maintenanceGuard] },
  { path: 'unauthorised', component: NotAuthorisedComponent, canActivate: [maintenanceGuard] },
  // Portal routes
  { path: '', redirectTo: 'checkaccess', pathMatch: 'full' },
  {
    path: '',
    component: AuthenticatedContainerComponent,
    canActivateChild: [maintenanceGuard],
    children: [
      ...SymptomCheckerRoutes,
      ...ShopRoutes,
      ...SecurityRoutes,
      ...DemoRoutes,
      ...SchedulingRoutes,
      ...OnboardingRoutes,
      ...MaintenanceRoutes,
      ...DashboardRoutes,
      ...ConsultationSetupRoutes,
      ...CustomerSuccessAdminRoutes,
      ...AccountRoutes,
      ...UsersRoutes,
      ...PrescriptionsRoutes,
      ...TrialsRoutes,
      ...EntitlementsRoutes,
      ...JoiiSessionsRoutes,
    ],
  },
  {
    path: MAINTENANCE_WINDOW_PATH,
    loadComponent: () =>
      import('src/shared/components/maintenance-window/maintenance-window-page/maintenance-window-page.component').then(
        (x) => x.MaintenanceWindowPageComponent
      ),
    title: 'Under Maintenance',
  },
  // 404: explicit route before wildcard so `/notfound` matches; `**` must be last
  { path: 'notfound', component: NotFoundComponent, canActivate: [maintenanceGuard] },
  { path: '**', redirectTo: 'notfound' },
];
